import { ConditionalLink } from '../ConditionalLink/ConditionalLink'
import { Badge, ClickArea, Dot, WrapIcon } from './IconButton.styles'
import type { IconButtonProps } from './IconButton.types'

export const IconButton = ({
  children,
  link,
  className,
  badge,
  dot,
  onClick,
  iconSize = '2rem',
  clickAreaSize = '4.8rem',
  buttonType,
  variant = 'primary',
  color,
  filled = true,
}: IconButtonProps): JSX.Element => {
  return (
    <ConditionalLink condition={Boolean(link)} href={link}>
      <ClickArea clickAreaSize={clickAreaSize} onClick={onClick}>
        <WrapIcon
          filled={filled}
          className={className}
          color={color}
          iconSize={iconSize}
          variant={variant}
          $buttonType={buttonType}
        >
          {children}
        </WrapIcon>
        {Boolean(badge) && <Badge>{badge}</Badge>}
        {dot && <Dot />}
      </ClickArea>
    </ConditionalLink>
  )
}
